export default __webpack_public_path__ + "static/media/brand_id_10.ef0269c0.png";